export const HOME_ASSISTANT_ARTICLE_ID = '52024566871827';

// Keep metadata separate so route SEO does not import the full article body.
export const homeAssistantArticleMetadata = {
  updated_at: '2026-11-05T12:00:00Z',
  excerpt: 'Connect HAVEN monitors to Home Assistant using the official Local HTTP integration. Find supported readings, setup help, and guidance for moving from an older integration.',
};
